import { get, isArray } from 'lodash'
import React from 'react'
import {
  Column,
  TableCellDataGetterParams,
  TableCellProps,
  TableHeaderProps,
} from 'react-virtualized'

import MobileColumn from '../MobileColumn'
import { ColumnInfinityProps, TColumn, TSort } from '../types'
import CellRendered from './CellRendered'
import HeaderRendered from './HeaderRendered'

// NB: limitation invalid hook call if use directly caused ColumnInfinity({})
// https://github.com/bvaughn/react-virtualized/issues/898
// as forwarded inherintance based react-virtualized

const ColumnInfinity = (props: ColumnInfinityProps): React.ReactElement => {
  const {
    column,
    selectionLimit,
    selectedItems,
    renderMobile,
    toggleAll,
    toggleAllState,
    sorts,
    applyFilter,
    setSort,
    sortableColumns,
    applyLocalSort,
    useLocalStateFiltering,
    ui,
    setCurrentRow,
    selectionKey,
    getIsSelectable,
    customRowDataKey,
    limitReached,
    toggleItem,
    mobileCellHeader,
    mobileCellBody,
    mobileCellHeaderItems,
    toggleMobileState,
    mobileToggleState,
    columns = [],
    direction,
  } = props

  const {
    dataKey,
    sortKey,
    flexGrow = 1,
    colWidth,
    isCheckColumn,
  } = column || {}

  const columnProps: TColumn = {
    ...column,
  }

  if (renderMobile) {
    columnProps.cellRenderer = (cellRendererProps) => (
      <MobileColumn
        {...cellRendererProps}
        mobileCellHeader={mobileCellHeader}
        mobileCellBody={mobileCellBody}
        mobileCellHeaderItems={mobileCellHeaderItems}
        toggle={toggleMobileState}
        isToggled={get(mobileToggleState, cellRendererProps.rowIndex as number)}
        columns={columns}
      />
    )
  }

  return (
    <Column
      key={get(column, 'label', '') as string}
      width={colWidth || colWidth || 100}
      flexGrow={flexGrow}
      style={{ ...(renderMobile ? { height: '100%' } : {}) }}
      headerRenderer={(props: TableHeaderProps) => {
        const { label, disableSort } = props
        return (
          <HeaderRendered
            label={label}
            disableSort={disableSort as boolean}
            isCheckColumn={isCheckColumn as boolean}
            toggleAllState={toggleAllState}
            toggleAll={toggleAll}
            direction={direction}
            sorts={sorts as TSort[]}
            sortKey={sortKey as string}
            applyFilter={applyFilter}
            setSort={setSort}
            sortableColumns={sortableColumns}
            applyLocalSort={applyLocalSort}
            useLocalStateFiltering={useLocalStateFiltering}
            ui={ui}
            setCurrentRow={setCurrentRow}
          />
        )
      }}
      cellRenderer={
        ((props: TableCellProps): React.ReactNode => {
          const { rowData, cellData } = props
          return (
            <CellRendered
              isCheckColumn={isCheckColumn as boolean}
              selectionKey={selectionKey}
              getIsSelectable={getIsSelectable}
              selectedItems={selectedItems}
              limitReached={limitReached}
              toggleItem={toggleItem}
              selectionLimit={selectionLimit}
              rowData={rowData}
              cellData={cellData}
            />
          )
        }) as any
      }
      cellDataGetter={({ rowData }: TableCellDataGetterParams) => {
        if (isArray(dataKey)) {
          const data = []
          dataKey.forEach((key) => {
            data[key] = get(rowData, key)
          })

          return data
        }
        return customRowDataKey !== ''
          ? get(rowData, `${customRowDataKey}.${dataKey}`)
          : get(rowData, dataKey as string)
      }}
      {...columnProps}
      dataKey={
        columnProps.dataKey ? (columnProps.dataKey as unknown as string) : 'id'
      }
    />
  )
}
export default ColumnInfinity
